import {tns} from 'tiny-slider/src/tiny-slider.js'

export default {
  init() {
    tns({
      container: '.slider',
      items: 1,
      autoplay: true,
      autoplayButton: false,
      autoplayButtonOutput: false,
      controls: false,
      navContainer: '.slider-controls',
      navPosition: 'bottom',
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js